import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-contact-us',
  templateUrl: './account-contact-us.component.html',
  styleUrls: ['./account-contact-us.component.scss']
})
export class AccountContactUsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
